import React from 'react'
import { Route } from 'react-router-dom'

import Activate from './Activate'
import Forgot from './Forgot'

const PasswordRoutes = () => (
  <div>
    <Route
      exact
      key="/password/activate"
      path="/password/activate"
      component={Activate}
    />
    <Route
      exact
      key="/password/forgot"
      path="/password/forgot"
      component={Forgot}
    />
  </div>
)

export default PasswordRoutes
